import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Functional guard to validate and ensure proper display parameter for AV view routes.
 * Token handling is done in auth guard for better separation of concerns.
 */
export const displayGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {

  const router = inject(Router);
  const display = route.queryParamMap.get('display');
  const deviceId = route.params['id'];

  // Validate display parameter
  const validDisplays = ['HDMI-1', 'HDMI-2'];
  if (!display || !validDisplays.includes(display)) {
    console.warn(`Invalid or missing display parameter: ${display}. Redirecting with HDMI-1`);

    // Preserve all query parameters and update display
    const queryParams = { ...route.queryParams, display: 'HDMI-1' };

    // Redirect with all query params preserved
    return router.createUrlTree(
      ['/av-view', deviceId],
      { queryParams }
    );
  }

  return true;
};